import { render, staticRenderFns } from "./subscription-form.vue?vue&type=template&id=193963e0&scoped=true&"
import script from "./subscription-form.ts?vue&type=script&lang=ts&"
export * from "./subscription-form.ts?vue&type=script&lang=ts&"
import style0 from "./subscription-form.scss?vue&type=style&index=0&id=193963e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193963e0",
  null
  
)

export default component.exports